import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { breakpoints } from 'shared/theme/breakpoints'
import styled, { css } from 'styled-components'

export const brandedNavigation = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 8px 0;
  box-sizing: border-box;

  #${NAV_LEFT_WRAP} {
    min-width: 0;
  }

  #${NAV_LEFT_WRAP}:empty {
    display: none;
  }

  #${NAV_LEFT_WRAP} > div {
    margin: 0;
  }

  @media ${breakpoints.sm} {
    #${NAV_LEFT_WRAP}:not(:empty) {
      order: 3;
      flex: 1 0 100%;
    }
  }
`

export const NavigationBrand = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 240px;

  > div {
    max-width: 100%;
  }

  img {
    max-width: 100%;
  }

  > div > div {
    white-space: normal;
    overflow-wrap: break-word;
  }

  @media ${breakpoints.xs} {
    max-width: 150px;
  }
`

export const NavigationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: auto;
`

/* Attention banners sit beside the actions on wide screens and take their own row on small ones. */
export const AttentionSlot = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  margin-left: auto;

  &:empty {
    display: none;
  }

  &:not(:empty) + ${NavigationActions} {
    margin-left: 0;
  }

  @media ${breakpoints.sm} {
    order: 4;
    flex: 1 0 100%;
    justify-content: stretch;
    margin-left: 0;

    > * {
      flex: 1;
    }

    &:not(:empty) + ${NavigationActions} {
      margin-left: auto;
    }
  }
`
